import { redirectRequestConfig } from "@/guards/auth/auth-config";
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";

export const acquireMsalToken = async (
  instance: IPublicClientApplication,
  account: AccountInfo,
) => {
  const { accessToken } = await instance.acquireTokenSilent({
    scopes: redirectRequestConfig.scopes,
    account: account,
  });

  return { accessToken };
};
